
















import { Component, Vue } from 'vue-property-decorator'
import { IMenuItem } from '@/models/ui/IMenuItem'

@Component({
  name:"MenuNav",
  components: {    
  },
  props:{    
    title:String,
    items:Array
  }
})
export default class MenuNav extends Vue {    
  title!:string
  items!:Array<IMenuItem>  
  hideTitle!:boolean
}
